function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import fixedClasses from '../payment-form-styling/payment-form-styling-fixed.scss';
import responsiveClasses from '../payment-form-styling/payment-form-styling.scss';
export class FormInput extends React.PureComponent {
  render() {
    const {
      children,
      width,
      isFixedStyles
    } = this.props;
    const classes = isFixedStyles ? fixedClasses : responsiveClasses;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.input,
      style: {
        width: `${width}%`
      }
    }, /*#__PURE__*/React.createElement("div", null, children));
  }
}
_defineProperty(FormInput, "defaultProps", {
  width: 100
});